
export default {
  data() {
    return {
      dataList: [
        {
          src: "/img/quote.webp",
          title: "Enterprise Name",
          text: "We’ve worked with UNIWELL for two years now. Every shipment is on time, and the logistics tracking is always up-to-date. Even during peak seasons, delivery dates are never delayed. They are our most reliable supply chain partner.",
          time: "August 26th,2024",
        },
        {
          src: "/img/quote.webp",
          title: "Enterprise Name",
          text: "The batch-to-batch consistency of Soy Isoflavones is impressive. Each shipment comes with detailed COAs, and the purity remains consistently high. UNIWELL’s quality control is truly trustworthy.",
          time: "December 7th,2023",
        },
        {
          src: "/img/quote.webp",
          title: "Enterprise Name",
          text: "The sales team is highly professional and always responds promptly. Whenever we have technical questions, they connect us with their R&D team. This level of responsiveness and service gives us full confidence in the partnership.",
          time: "May 11th, 2024",
        },
        {
          src: "/img/quote.webp",
          text: "From small trial orders to stable bulk purchases, UNIWELL has maintained the same high quality and sincere service throughout. After five years of cooperation, they have become one of our most important strategic suppliers.",
        },
      ],
      activeIndex: 0,
      swiperOption: {
        // slidesPerView: 5,
        // spaceBetween: 30,
        // centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: ".swiper-evaluate-next",
          prevEl: ".swiper-evaluate-prev",
        },
        // autoplay: {
        //     delay: 2000,
        //     disableOnInteraction: false,
        // },
        breakpoints: {
          1200: {
            slidesPerView: 3,
          },
          700: {
            slidesPerView: 1,
          },
          600: {
            slidesPerView: 1,
          },
          500: {
            slidesPerView: 1,
          },
          400: {
            slidesPerView: 1,
          },
          300: {
            slidesPerView: 1,
          },
          200: {
            slidesPerView: 1,
          },
        },
      },
    };
  },
};
